@let light = variant() === 'light';

<!-- NOTE: We use queryParamsHandling="preserve" here to make sure
           the ecmp header queryParam will stay on navigation -->
<a
  [attr.aria-label]="label()"
  role="link"
  [routerLink]="url()"
  queryParamsHandling="preserve"
  class="navbar-brand navigation__logo"
  [class.navigation__logo--light]="light"
  wlTrackLink
  [trackLinkInfo]="{
    rendering: { componentName: 'NavigationEcmpLogoComponent' },
    field: label() ?? '',
    eventType: 'link-click',
    type: 'image',
  }"
>
  <wl-logo [variant]="variant()" [width]="width()" [height]="height()" />
</a>
